import { render, staticRenderFns } from "./AssinaturasHojeCard.vue?vue&type=template&id=161b8972"
import script from "./AssinaturasHojeCard.vue?vue&type=script&lang=ts"
export * from "./AssinaturasHojeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports